import "./Hero.css";
import homepageVideo from "../assets/images/home/home_video.mp4";
import homepageVideoSnapshot from "../assets/images/home/home_video_snapshot.png";
import { useIsDesktop } from "../hooks/useIsDesktop";

type HeroProps = {
  page: string;
  titleOne?: React.ReactNode;
  titleTwo: string;
  contrastColor?: boolean;
};

const Hero = ({ page, titleOne, titleTwo, contrastColor }: HeroProps) => {
  const isVideoHero = page === "home";
  const isTabletUp = useIsDesktop(767);
  const showHomeVideo = isVideoHero && isTabletUp;

  return (
    <section className={`hero-container ${page}-hero-background`}>
      {showHomeVideo && (
        <video
          className="hero-background-video"
          autoPlay
          loop
          muted
          playsInline
          poster={homepageVideoSnapshot}
          aria-hidden="true"
        >
          <source src={homepageVideo} type="video/mp4" />
        </video>
      )}
      <div className="hero-text-container">
        {titleOne && <h1>{titleOne}</h1>}
        <h2 className={contrastColor ? "hero-contrast-color" : ""}>
          {titleTwo}
        </h2>
      </div>
    </section>
  );
};

export default Hero;
